import React, {useState} from 'react';
import styles from './PlaceReviewsCard.module.scss';
import {IProduct} from 'data/interfaces/products';
import InfoCard from 'gui/pages/mainRouter/pages/ad/components/commons/infoCard';
import {MDBCol, MDBContainer, MDBRow} from 'mdbreact';
import ChatBubbleRoundedIcon from '@material-ui/icons/ChatBubbleRounded';
import PlaceReview from './components/placeReview';
import LinkBlock from 'gui/components/linkBlock';
import {randomArrayValue} from 'data/utils/calculators';
import fill from 'fill-range';
import {If, Else, Then, Unless, When} from 'react-if';
import {getPlaceDetails, isVoucherWithPlace} from 'data/redux/selectors/productSelector';

interface IPlaceReviewsCardProps {
  product?: IProduct;
  initialReviewsShown?: number;
  disableLoadMore?: boolean;
}

const PlaceReviewsCard = (props: IPlaceReviewsCardProps) => {
  if (isVoucherWithPlace(props.product)) {
    const [showMoreCount, addShowMore] = useState(props.initialReviewsShown);
    const placeDetails = getPlaceDetails(props.product);
    return (
      <When
        condition={!!(placeDetails && placeDetails.reviews && placeDetails.reviews.length)}>{
        () => <InfoCard
          className={styles.placeReviewsCard}
          title={(<>
            <span className={styles.placeReviewsTitleRight}>ביקורת</span>
            <span>
          (מאת <LinkBlock style={{display: 'inline', padding: 0, margin: 0}}
                          href={randomArrayValue(...placeDetails.reviews).author_url}>&nbsp;Google</LinkBlock>):
          </span>
          </>)}
          icon={ChatBubbleRoundedIcon}
          toolTip="ביקורות"
        >
          <MDBContainer fluid>
            {fill(0, Math.min(showMoreCount, placeDetails.reviews.length / 2)).map(index => (
              <MDBRow key={index} style={{marginBottom: 15}} className="animated flipInX">
                {fill(0, 1).map(i => <MDBCol key={i} sm="6">
                  <If condition={placeDetails.reviews.length > i + (2 * index)}>
                    <Then>{() => <PlaceReview
                      review={placeDetails.reviews[i + (2 * index)]}/>}</Then>
                  </If>
                </MDBCol>)}
              </MDBRow>
            ))}
            <Unless condition={props.disableLoadMore}>{() =>
              <MDBRow>
                <MDBCol sm="12">
                  <If condition={placeDetails.reviews.length / 2 > showMoreCount + 1}>
                    <Then>
                      <div className={styles.showMoreButton} onClick={() => addShowMore(showMoreCount + 1)}>טען ביקורות
                        נוספות
                      </div>
                    </Then>
                    <Else>
                      <LinkBlock href={placeDetails.url} style={{padding: 0, margin: 0}}>
                        <div className={styles.showMoreButton}>טען ביקורות נוספות</div>
                      </LinkBlock>
                    </Else>
                  </If>
                </MDBCol>
              </MDBRow>
            }</Unless>
          </MDBContainer>
        </InfoCard>
      }
      </When>
    )
  }
  return null;
};

PlaceReviewsCard.defaultProps = {
  initialReviewsShown: 0,
  disableLoadMore: false,
};

export default React.memo(PlaceReviewsCard);
